import { _ } from "@icc/shared/helpers";

export interface Delivery {
    id?: number;
    uuid: string;
    externalId: string | null;
    documentId: string;
    sellerCompanyId: number;
    driverUserId: number;
    positions: Record<string, 'sent' | 'delivered'>;
    signatureImage?: string | null;
    isConfirmed: boolean;
    driverNote: string;
    isDeleted?: boolean;
    created: Date;
    modified: Date;
    /**
     * Czas utworzenia dokumentu na serwerze
     */
    createdServer?: Date;

    /**
     * Czas modyfikacji dokumentu na serwerze
     */
    modifiedServer?: Date;

    $dirty?: boolean;
}

export type DeliveryDto = Omit<Delivery, 'positions'> & {
    positions: string;
};

export const DeliveryNonReadableProps = [
    'id',
    'uuid',
    'created',
    'modified',
    'createdServer',
    'modifiedServer',
    '$dirty',
    'sellerCompanyId',
] as const;

export const DeliveryReadablePropsNames: Record<Exclude<keyof Delivery, typeof DeliveryNonReadableProps[number]>, string> = {
    externalId: _('DELIVERY|Zewnętrzne ID'),
    documentId: _('DELIVERY|Dokument'),
    driverUserId: _('DELIVERY|Kierowca'),
    positions: _('DELIVERY|Pozycje'),
    signatureImage: _('DELIVERY|Podpis'),
    isDeleted: _('DELIVERY|Usunięta'),
    isConfirmed: _('DELIVERY|Potwierdzono'),
    driverNote: _('DELIVERY|Notatka kierowcy'),
};